import publishedCmsPages from '~~/public/cms-schemas/published-pages.json';
import { excludeCmsPageGroups } from '~~/helpers/cms/publishedCmsPages';
import type { PublishedCmsPages } from '~~/helpers/cms/publishedCmsPages';
import { isCustomFieldTruthy } from '~~/helpers/customFields';
import { CMS_PAGE_LABELS } from '~~/constants/cms';
import { STORE_CUSTOM_FIELDS } from '~~/constants/commerceTools';
import { useStoreCustomFields } from '~/composables/useStoreCustomFields';

// isEnabled reflects only the CommerceTools store config toggle — not whether the page is
// actually present in published-pages.json. It can only ever cause excludeCmsPageGroups to
// remove entries that are already there; it can never restore one that's missing.
const useDynamicCmsPageGroupFlags = (): Array<{ group: string, isEnabled: ComputedRef<boolean> }> => {

  const { customFieldsRaw } = useStoreCustomFields();

  return [
    {
      group: CMS_PAGE_LABELS.PREMIUM_GUARANTEE,
      isEnabled: computed(() =>
        isCustomFieldTruthy(customFieldsRaw.value, STORE_CUSTOM_FIELDS.EXTRA_GUARANTEE_ENABLED)),
    },
  ];

};

export const useDynamicPublishedCmsPages = () => {

  const dynamicCmsPageGroupFlags = useDynamicCmsPageGroupFlags();

  const disabledCmsPageGroups = computed(() =>
    dynamicCmsPageGroupFlags
      .filter(({ isEnabled }) => !isEnabled.value)
      .map(({ group }) => group),
  );

  const publishedPages = computed<PublishedCmsPages>(() =>
    excludeCmsPageGroups(publishedCmsPages, disabledCmsPageGroups.value),
  );

  return { publishedPages };

};
